import styled from 'styled-components';

export const ContainerProgressPage = styled.div`
  .list-tools {
    position: sticky;

    background: ${(props) => props.theme.$bg_gray};

    top: 3.8em;

    z-index: 12;

    @media (max-width: 992px) {
      top: 3em;
    }
  }

  .itemToolsSelected {
    bottom: 2px;

    font-size: 0.9rem;

    background-color: #007bff1a;

    padding: 15px 20px;

    border-radius: 4px;

    button {
      font-size: 1em;

      border: none;

      background-color: unset;

      box-shadow: none;
    }
  }

  .rdt_TableHeadRow {
    color: ${(props) => props.theme.$gray700};
    background-color: ${(props) => props.theme.$gray200};
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 0.2rem 0.2rem 0 0;

    div {
      color: ${(props) => props.theme.$gray700};
      white-space: inherit;
      font-size: 14px;
    }
  }

  .rdt_TableCell {
    padding-bottom: 8px;
    padding-top: 8px;
  }
`;
